import { object, ref, string } from 'yup';

import { messages, trim } from '../../../../data/utils/form.utils';

export const schema = object()
  .shape({
    password: string()
      .transform(trim)
      .matches(
        /^(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[a-zA-Z.><!#$@^%&? _-])[a-zA-Z0-9.><!#$@^%&? _-]{8,100}$/,
        messages.invalidPassword.id
      )
      .required(messages.required.id)
      .default(''),
    passwordConfirm: string()
      .transform(trim)
      .matches(
        /^(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[a-zA-Z.><!#$@^%&? _-])[a-zA-Z0-9.><!#$@^%&? _-]{8,100}$/,
        messages.invalidPassword.id
      )
      .required(messages.required.id)
      .oneOf([ref('password')], messages.invalidNotMatching.id)
      .default(''),
  })
  .required()
  .noUnknown();
